import type { HostelImage } from "../types";

export const getHostelImageSrc = (image: HostelImage) => {
  const apiBase = (
    import.meta.env.VITE_API_URL || "http://localhost:3000/api/v1"
  ).replace(/\/+$/, "");

  return image.id
    ? `${apiBase}/facilities/hostel-images/${encodeURIComponent(image.id)}/file`
    : image.url;
};

export const getHostelCoverImage = (images?: HostelImage[]) => {
  const cover =
    images?.find((image) => image.isCover && (image.id || image.url)) ||
    images?.find((image) => image.id || image.url);
  return cover ? getHostelImageSrc(cover) : null;
};
